import firebase from '../../firebase/compat';

// Single client entry point to the saveQuestionnaireResponse Cloud Function.
// The public questionnaire form runs logged-out, so all response writes go
// through this callable (admin SDK) instead of direct Firestore access —
// QuestionnairesResponses rules are locked down to team-only.
// The CF must be called in europe-west1 explicitly; the default client
// points at us-central1 and won't find it.

/**
 * @typedef {object} SaveResponsePayload
 * @property {number} timestampMillis - Shared submission timestamp (ms) — groups all docs of one submission
 * @property {Array<{response: object, isMatrix: boolean}>} responses - One entry per answered field/row/option (PascalCase response doc)
 * @property {object} [field] - Optional multiple-multiple cleanup scope (dedup tuple + KeepItemids)
 */

/**
 * @param {SaveResponsePayload} payload - Batched responses to save
 * @returns {Promise<object>} CF result data
 */
const callSaveQuestionnaireResponse = async (payload) => {
    const saveFn = firebase.app().functions('europe-west1').httpsCallable('saveQuestionnaireResponse');
    const { data } = await saveFn(payload);
    return data;
};

export default callSaveQuestionnaireResponse;
